export default "__VITE_ASSET__CGr3O570__"